// removed by extract-text-webpack-plugin
module.exports = {"BackImgFixed":"BackImg__BackImgFixed__1KawL","BackImg":"BackImg__BackImg__19GaM","BackImgParallax":"BackImg__BackImgParallax__27P7M"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/BackImg/BackImg.css
// module id = 349
// module chunks = 0